<template>
    <div class="dept-container">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                class="search-form"
                label-position="top"
                :model="search_data"
                style="padding: 0 20px"
            >
                <el-form-item label="登录地址">
                    <el-input v-model="search_data.ip" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="用户名称">
                    <el-input v-model="search_data.username" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <div class="circle-btn">
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="formVisible ? '隐藏搜索' : '显示搜索'"
                            placement="top"
                        >
                            <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                            <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                        </el-tooltip>
                    </div>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="session" label="会话编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="登录名称"></el-table-column>
                <el-table-column prop="department_name" label="部门名称"></el-table-column>
                <el-table-column prop="ip" label="主机"></el-table-column>
                <el-table-column prop="browser" label="浏览器"></el-table-column>
                <el-table-column prop="os" label="操作系统"></el-table-column>
                <el-table-column prop="login_time" label="登陆时间" sortable width="180"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template #default="{ row }">
                        <el-button type="primary" plain link @click="delOnlineUser(row)" :icon="Delete" size="small">
                            强退
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { delOnline, getOnline } from '@/api/monitor.js'
import { Delete, Refresh, Search } from '@element-plus/icons'
import { ElMessage, ElMessageBox } from 'element-plus'
// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
const search_data = ref({
    username: '',
    ip: ''
})
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)
// 获取数据的方法
const getTableData = async () => {
    const result = await getOnline({
        page: page.value,
        page_size: size.value,
        ...search_data.value
    })
    table_data.value = result.lists
    total.value = result.total
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

// 强退
const delOnlineUser = (row) => {
    ElMessageBox.confirm(`是否确认强退名称为"${row.name}"的用户`, {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
    })
        .then(async () => {
            await delOnline(row.session)
            ElMessage.success('强退成功')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped></style>
